
namespace appn.views.brandCenter.customConnector {

    export function init(): void {
        addEvents();
    }

    function addEvents(): void {
        $('.buildIcon').on('click', function() {
            const formulaBox = $(this).closest('.input-group').find('.form-control');
            appn.ui.formulabuilder.currentFormula = formulaBox.val() as string;
            appn.ui.formulabuilder.currentMode = $(this).data('type');
            appn.ui.formulabuilder.formulaUpdated = function(formula: string) {
                formulaBox.val(formula);
            };
            
            appn.ui.formulabuilder.showDialog();
        });
    }
}
